const OrderList = () => import('Views/order/order-list');
const OrderDetail = () => import('Views/order/order-detail');

export default[
  { path: '/order-list', component: OrderList },
  { path: '/order-detail/:id', component: OrderDetail },
];



// WEBPACK FOOTER //
// ./src/router/order.js